import { initModule } from './init-module';

export { cobLibrary } from './cob-library.config';

initModule();

export { FormInstruction } from './components/forms/form-instruction/form-instruction';
export { CobLibraryRoutes } from './cob-library.routes';
export { cobRoutesMap } from './init-module';
